import { useCallback } from "react";
import FileSaver from "file-saver";
import buttonClasses from "../../components/commons/Button.module.scss";
import classes from "./index.module.scss";

export default function CardCreator({ card }) {
  const {
    firstName,
    lastName,
    title,
    email,
    work,
    mobile,
    linkedin,
    telegram,
    whatsapp,
    facebook,
    instagram,
    website,
  } = card;

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      const file = new Blob(
        [
          `BEGIN:VCARD
VERSION:3.0
N:${lastName};${firstName};;;
FN:${firstName} ${lastName}
TITLE:${title};
EMAIL;type=INTERNET;type=pref:${email}
TEL;type=MAIN:${work.tel}
URL;type=website;CHARSET=UTF-8:${website}
${mobile && `TEL;type=CELL;type=VOICE;type=pref:${mobile.tel}`}
${instagram && `X-SOCIALPROFILE;TYPE=instagram:${instagram}`}
${linkedin && `X-SOCIALPROFILE;TYPE=linkedin:${linkedin}`}
${telegram && `X-SOCIALPROFILE;TYPE=telegram:${telegram}`}
${whatsapp && `X-SOCIALPROFILE;TYPE=whatsapp:${whatsapp}`}
${facebook && `X-SOCIALPROFILE;TYPE=facebook:${facebook}`}
END:VCARD
`,
        ],
        { type: "text/vcard;charset=utf-8" }
      );
      FileSaver.saveAs(file, `${firstName}${lastName}.vcf`);
    },
    [
      email,
      facebook,
      firstName,
      instagram,
      lastName,
      linkedin,
      mobile,
      telegram,
      title,
      whatsapp,
      work.tel,
      website,
    ]
  );

  return (
    <button
      onClick={handleClick}
      data-content="Save to contacts"
      className={`${buttonClasses.button} ${classes.button}`}
    >
      Save to contacts
    </button>
  );
}
